(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["batch-search"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalizeHandle = (value) => value
    .trim()
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  document.querySelectorAll('[data-batch-lookup]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('[data-batch-form]');
    const input = root.querySelector('[data-batch-input]');
    const button = root.querySelector('[data-batch-submit]');
    const message = root.querySelector('[data-batch-message]');
    const basePath = (root.dataset.basePath || '/pages/charge/').replace(/\/+$/, '') + '/';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      message.textContent = '';

      const handle = normalizeHandle(input.value);
      if (!handle) {
        message.textContent = 'Bitte gib deine Chargennummer ein.';
        input.focus();
        return;
      }

      const target = `${basePath}${encodeURIComponent(handle)}`;
      root.classList.add('is-loading');
      button.disabled = true;

      try {
        const response = await fetch(target, {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('not-found');

        window.location.assign(target);
      } catch (error) {
        message.textContent = 'Diese Chargennummer wurde nicht gefunden. Bitte prüfe die Eingabe.';
        root.classList.remove('is-loading');
        button.disabled = false;
        input.focus();
        input.select();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-charge-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  document.querySelectorAll('[data-charge-story]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const slides = [...root.querySelectorAll('[data-slide]')];
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const share = root.querySelector('[data-share]');
    const current = root.querySelector('[data-current]');
    const total = root.querySelector('[data-total]');
    const progress = root.querySelector('[data-progress]');
    const toast = root.querySelector('[data-toast]');
    let index = 0;
    let touchStartX = null;
    let touchStartY = null;
    let toastTimer;
    let resizeFrame = null;

    if (!slides.length) return;

    /*
      Mobile-Höhe robust gegen Shopify-Header, Announcement-Bar und
      dynamische Browserleisten berechnen. Entscheidend ist nicht eine
      angenommene Header-Höhe, sondern die echte Position der Story im Dokument.
    */
    const getOverlayHeaderBottom = () => {
      const selectors = [
        'sticky-header',
        '.header-wrapper',
        '.section-header',
        '.shopify-section-group-header-group',
        '[id*="shopify-section"][class*="header"]',
        'header'
      ];

      const elements = [...new Set(selectors.flatMap((selector) => [...document.querySelectorAll(selector)]))];
      let bottom = 0;

      elements.forEach((element) => {
        if (element === root || root.contains(element)) return;

        const style = getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        if (style.position !== 'fixed' && style.position !== 'sticky') return;

        const rect = element.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0) return;
        if (rect.top > 180) return;

        bottom = Math.max(bottom, rect.bottom);
      });

      return Math.max(0, bottom);
    };

    const syncMobileGeometry = () => {
      if (!window.matchMedia('(max-width: 820px)').matches) {
        root.style.removeProperty('--charge-story-height');
        root.style.removeProperty('--charge-chrome-space');
        return;
      }

      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const rect = root.getBoundingClientRect();
      const documentTop = rect.top + window.scrollY;
      const overlayHeaderBottom = getOverlayHeaderBottom();

      // documentTop erfasst Header + Announcement-Bar, wenn sie im normalen Flow liegen.
      // Bei einem überlagernden fixed/sticky Header greift overlayHeaderBottom.
      const flowTop = Math.max(0, Math.min(documentTop, viewportHeight * 0.34));
      const topOffset = Math.max(flowTop, overlayHeaderBottom);
      const storyHeight = Math.max(0, viewportHeight - topOffset);

      root.style.setProperty('--charge-story-height', `${Math.round(storyHeight)}px`);

      // Platz für die tatsächlich gerenderte Navigation reservieren.
      const chrome = root.querySelector('.charge-story__chrome');
      if (chrome) {
        const chromeHeight = chrome.getBoundingClientRect().height;
        root.style.setProperty('--charge-chrome-space', `${Math.ceil(chromeHeight + 26)}px`);
      }
    };

    const requestGeometrySync = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(syncMobileGeometry);
    };

    total.textContent = pad(slides.length);
    syncMobileGeometry();
    requestAnimationFrame(syncMobileGeometry);
    setTimeout(syncMobileGeometry, 250);

    window.addEventListener('resize', requestGeometrySync, { passive: true });
    window.addEventListener('orientationchange', requestGeometrySync, { passive: true });
    window.visualViewport?.addEventListener('resize', requestGeometrySync, { passive: true });

    const showToast = (text) => {
      clearTimeout(toastTimer);
      toast.textContent = text;
      toast.classList.add('is-visible');
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
    };

    const goTo = (nextIndex, updateHash = true) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      current.textContent = pad(index + 1);
      progress.style.width = `${((index + 1) / slides.length) * 100}%`;
      requestAnimationFrame(syncMobileGeometry);

      if (updateHash) {
        history.replaceState(null, '', `${location.pathname}${location.search}#slide-${index + 1}`);
      }
    };


    const shareCurrent = async () => {
      const slide = slides[index];
      const title = slide.dataset.shareTitle || document.title;
      const url = `${location.origin}${location.pathname}${location.search}#slide-${index + 1}`;
      const imageUrl = (window.matchMedia('(max-width: 820px)').matches && slide.dataset.shareImageMobile) || slide.dataset.shareImage;

      if (navigator.share) {
        if (imageUrl && navigator.canShare) {
          try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const extension = (blob.type.split('/')[1] || 'jpg').replace('jpeg', 'jpg');
            const file = new File([blob], `manuka-charge-${index + 1}.${extension}`, { type: blob.type || 'image/jpeg' });

            if (navigator.canShare({ files: [file] })) {
              await navigator.share({ title, text: title, url, files: [file] });
              return;
            }
          } catch (error) {
            // Fallback below: share URL only.
          }
        }

        try {
          await navigator.share({ title, text: title, url });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }

      try {
        await navigator.clipboard.writeText(url);
        showToast('Slide-Link kopiert');
      } catch (error) {
        window.prompt('Diesen Link kopieren:', url);
      }
    };

    prev.addEventListener('click', () => goTo(index - 1));
    next.addEventListener('click', () => goTo(index + 1));
    share.addEventListener('click', shareCurrent);

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') goTo(index - 1);
      if (event.key === 'ArrowRight') goTo(index + 1);
    });

    root.tabIndex = 0;

    root.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    root.addEventListener('touchend', (event) => {
      if (touchStartX === null || touchStartY === null) return;

      const touch = event.changedTouches[0];
      const distanceX = touch.clientX - touchStartX;
      const distanceY = touch.clientY - touchStartY;

      touchStartX = null;
      touchStartY = null;

      // Vertikales Scrollen in Text/PDF-Slides nicht als Slide-Wechsel werten.
      if (Math.abs(distanceY) > Math.abs(distanceX)) return;
      if (Math.abs(distanceX) < 44) return;

      goTo(distanceX < 0 ? index + 1 : index - 1);
    }, { passive: true });

    const hashMatch = location.hash.match(/^#slide-(\d+)$/);
    if (hashMatch) {
      const requested = Math.min(Math.max(Number(hashMatch[1]) - 1, 0), slides.length - 1);
      goTo(requested, false);
    } else {
      goTo(0, false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
